import { useTranslation } from 'react-i18next';

import EmptyTasksIcon from '@crm/shared/assets/icons/empty-tasks.svg?react';
import { SvgIcon } from '@crm/shared/ui';

export const EmptyTasks = () => {
    const { t } = useTranslation();

    return (
        <div className="flex h-full w-full flex-col items-center justify-center gap-3">
            <SvgIcon size={120} icon={EmptyTasksIcon} />
            <h1 className="m-0 self-stretch text-center text-[18px] leading-6 font-semibold text-gray-800">
                {t('crm.dealDetailsContent.tasksBlock.empty.title')}
            </h1>
        </div>
    );
};
